export default "__VITE_ASSET__2f8cb5ab__"